<script>
import { GlButton, GlTooltipDirective } from '@gitlab/ui';
import { __ } from '~/locale';
import { createAlert } from '~/alert';
import { FLOW_TRIGGER_TYPE_ASSIGN } from 'ee/ai/duo_agents_platform/constants';
import updateWorkItemMutation from '~/work_items/graphql/update_work_item.mutation.graphql';
import getDuoDeveloperServiceAccount from '../graphql/get_duo_developer_service_account.query.graphql';

export default {
  name: 'DuoAssignDeveloperButton',
  directives: {
    GlTooltip: GlTooltipDirective,
  },
  components: {
    GlButton,
  },
  props: {
    workItemId: {
      type: String,
      required: true,
    },
    projectGid: {
      type: String,
      required: true,
    },
    currentAssigneeIds: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      isAssigning: false,
      serviceAccountGid: null,
    };
  },
  apollo: {
    serviceAccountGid: {
      query: getDuoDeveloperServiceAccount,
      variables() {
        return {
          projectId: this.projectGid,
        };
      },
      context: {
        featureCategory: 'duo_agent_platform',
      },
      skip() {
        return !this.projectGid;
      },
      update(data) {
        const trigger = data.aiCatalogConfiguredItems?.nodes?.[0]?.flowTrigger;
        if (trigger?.eventTypes?.includes(FLOW_TRIGGER_TYPE_ASSIGN.valueInt) && trigger?.user?.id) {
          return trigger.user.id;
        }
        return null;
      },
      error(error) {
        createAlert({
          message: error?.message || __('Something went wrong'),
          captureError: true,
          error,
        });
      },
    },
  },
  computed: {
    isVisible() {
      return Boolean(this.serviceAccountGid);
    },
  },
  methods: {
    async assignDeveloper() {
      this.isAssigning = true;

      try {
        const {
          data: {
            workItemUpdate: { errors },
          },
        } = await this.$apollo.mutate({
          mutation: updateWorkItemMutation,
          variables: {
            input: {
              id: this.workItemId,
              assigneesWidget: {
                assigneeIds: [...new Set([...this.currentAssigneeIds, this.serviceAccountGid])],
              },
            },
          },
        });

        if (errors.length > 0) {
          throw new Error(errors.join(', '));
        }
      } catch (error) {
        createAlert({
          message: __('Failed to assign Duo Developer.'),
          captureError: true,
          error,
        });
      } finally {
        this.isAssigning = false;
      }
    },
  },
};
</script>
<template>
  <gl-button
    v-if="isVisible"
    v-gl-tooltip.hover.focus.viewport="{ placement: 'top' }"
    icon="tanuki-ai"
    :loading="isAssigning"
    :title="__('Generate merge request with Duo')"
    size="medium"
    data-testid="duo-assign-developer-button"
    @click="assignDeveloper"
    >{{ __('Generate MR with Duo') }}</gl-button
  >
</template>
